import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {
    toggleFeaturesSetupSharedFeatureName,
} from "./featuresActions";
import UiSwitch from '../PageLayout/UiSwitch';


const FeaturesSetupTopPanelSharedFeatureNameToggle = (props) => {
    const { sharedFeatureNameToggleValue, toggleFeaturesSetupSharedFeatureName } = props;

    const onToggleClick = () => {
        toggleFeaturesSetupSharedFeatureName(!sharedFeatureNameToggleValue);
    }

    return (
        <div className="en-group text-center">
            <div className="en-group__title">
                Shared Feature Name Edit
            </div>
            <div className="en-group__buttons">
                <UiSwitch onClick={() => onToggleClick()}
                    checked={sharedFeatureNameToggleValue} />
            </div>
        </div>
    )
};

const mapStateToProps = (store) => {
    const { sharedFeatureNameToggleValue } = store.featuresSetupState;
    return { sharedFeatureNameToggleValue };
};

const mapDispatchToProps = {
    toggleFeaturesSetupSharedFeatureName
};

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)
        (FeaturesSetupTopPanelSharedFeatureNameToggle)
)
